import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RowBody } from "../../../components/RowValue/RowBody";
import { DRUCKPFAHL, ZUGPFAHL } from "../../../constants.js";
import { setModelFaktor, setTeilsicherheitsbeiwert } from "../../../store/slices/aeussereSlice";
import {
  selectBelastungsartUndRichtung,
  setBelastungsartUndRichtung,
} from "../../../store/slices/belastungsartUndRichtungSlice";
import {
  BemessungenMikropfaehle,
  selectBemessungenMikropfaehle,
} from "../../../store/slices/bemessungenMikropfaehleSlice";

function LoadType({ readOnly = false }) {
  const { t } = useTranslation("translation");

  const dispatch = useDispatch();
  const belastungsartUndRichtung = useSelector(selectBelastungsartUndRichtung);
  const bemessungenMikropfaehle = useSelector(selectBemessungenMikropfaehle);

  function renderBelastungsartUndRichtung(val) {
    switch (val) {
      case DRUCKPFAHL:
        return t("inner.compressionPile");
      case ZUGPFAHL:
        return t("inner.tensionPile");
    }
  }

  function renderInput() {
    if (readOnly) {
      return (
        <span className="input">{renderBelastungsartUndRichtung(belastungsartUndRichtung)}</span>
      );
    }

    return (
      <select
        className="change-input"
        onChange={(e) => {
          dispatch(setBelastungsartUndRichtung(e.target.value));

          let value;
          if (e.target.value == DRUCKPFAHL) value = 1.4;
          if (e.target.value == ZUGPFAHL) value = 1.5;
          dispatch(setTeilsicherheitsbeiwert(value));

          if (
            bemessungenMikropfaehle === BemessungenMikropfaehle.EUROCODE_7 ||
            e.target.value == DRUCKPFAHL
          ) {
            dispatch(setModelFaktor(1.0));
          } else {
            dispatch(setModelFaktor(1.25));
          }
        }}
        name="belastungsartUndRichtung"
        id="belastungsartUndRichtung"
        value={belastungsartUndRichtung}
      >
        <option key={1} value={DRUCKPFAHL}>
          {renderBelastungsartUndRichtung(DRUCKPFAHL)}
        </option>
        <option key={2} value={ZUGPFAHL}>
          {renderBelastungsartUndRichtung(ZUGPFAHL)}
        </option>
      </select>
    );
  }

  return <RowBody titleValue={<p>{t("inner.loadType")}</p>} inputValue={renderInput()} />;
}

export default LoadType;
